export enum SitePlatform {
  DESKTOP = "desktop",
  MOBILE = "mobile",
}

export enum UserLoginStatus {
  LOGGED = "1",
  LOGGED_OUT = "2",
}
export type DataLayerDTO = {
  site?: {
    [key: string]: unknown;
  };
  page?: {
    [key: string]: unknown;
  };
  [key: string]: unknown;
};
